import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  Injector,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { isNullOrEmpty } from '../../../core/utils';
import { EnhancedFormControl } from '../../../models/rt-common';
import { BaseComponent } from '../../../shared/components/base.component';

@Component({
  selector: 'sigv-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
})
export class InputCheckboxComponent extends BaseComponent implements OnInit, OnChanges {
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** 欲綁定formControl欄位名稱
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /** 下拉選單選項 */
  @Input() selectOptions: SelectItem[] = [];
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /** 選項是否垂直顯示 */
  @Input() isVertical: boolean = false;
  /** 選項是否公版方式顯示 一列五個選項自動換行 */
  @Input() isTemplate: boolean = false;
  /** 選項是否多選 */
  @Input() isMultiSelect: boolean = true;
  /** 選項是否只有true/false */
  @Input() isBinary: boolean = false;
  /** 是否disabled*/
  @Input() disabled: boolean = false;
  /** isReadOnly = true && isMultiSelect = true 時是否顯示 checkBox */
  @Input() showCheckBox: boolean = false;
  /** isReadOnly = true && isBinary = true 時是否顯示 label */
  @Input() showLabel: boolean = false;
  /** isReadOnly = true && isMultiSelect = true 時是否顯示 checkBox */
  @Input() showCheckBoxWhenReadonly: boolean = false;
  /** 其他選項的輸入框 */
  @Input() otherCommentFormControl?: AbstractControl | any;
  /** 其他選項值 */
  @Input() otherCommentValue: string = '99';
  @Output() onChange = new EventEmitter<void>();
  constructor(
    injector: Injector,
  ) {
    super(injector);
  }
  value: EnhancedFormControl<string[]> = new EnhancedFormControl<string[]>({
    isFormArray: true,
  });
  onChangeEvent(event: any, selectOptionVal: string): void {
    // 多選
    if (this.isMultiSelect) {
      const removeEmptyString = event.checked.filter(
        (item: any) => item !== ''
      );
      this.bindingFormControl.setValue(removeEmptyString.join(','));
      this.onChange.emit(event);
    }
    // 單選
    else {
      if (this.isBinary) {
        event.checked = event.checked;
      } else {
        event.checked = event.checked[0] ? [selectOptionVal] : event.checked;
      }
      this.bindingFormControl.setValue(event.checked);
      this.onChange.emit(event);
    }
    this.logger.debug('onCHangeEvent input-checkbox', event);
  }

  patchValue() {
    if (this.isBinary) {
      this.value.patchValue(this.bindingFormControl.getRawValue());
    } else {
      const valueArray = String(
        this.bindingFormControl?.getRawValue() ??
          this.bindingFormControl?.value ??
          ''
      )?.split(',');
      this.value.patchValue(valueArray);
    }
  }
  onSubscribeValue(): void {
    this.bindingFormControl?.valueChanges.subscribe((changeValue: any) => {
      if (this.isBinary) {
        this.value.patchValue(changeValue);
      } else {
        const valueArray = String(
          changeValue ?? this.bindingFormControl?.value ?? ''
        )?.split(',');
        this.value.patchValue(valueArray);
      }
    });
  }

  ngOnInit() {
    this.patchValue();
    this.onSubscribeValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isNullOrEmpty(this.bindingFormControl?.value)) {
      this.patchValue();
    }
  }
}
